import React, {useEffect, useState} from 'react'
import '../assets/css/Panel.css'
import Navbar from "../components/Navbar";
import ExamCard from "../components/ExamCard";
import GashtaltImage from '../assets/images/gavazn.png'
import {useNavigate} from "react-router-dom";
import {api} from "../utils/gashtaltAPI";
import {useDispatch} from "react-redux";
import Loader from "../components/Loader";

function PastExams() {
    const [exams, setExams] = useState([]);
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/exam/past')
                setExams(response.data.data);
            } catch (error) {

            }finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);
    if (loading) return <Loader />
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="cards-container row flex-fill justify-content-center align-items-center">
                {exams.length===0 && (
                    <h1 className="text-center">آزمونی یافت نشد!</h1>
                )}
                {exams.map((exam, index) => (
                    <ExamCard Image={GashtaltImage} id={exam.id} name={exam.name} questionCount={exam.questions_count} hasPaid={exam.hasPaid} price={exam.price}
                              time={exam.duration} editor={exam.editor} authors={exam.authors} past={true} questions_file={exam.questions_file ?? null} answers_file={exam.answers_file ?? null} />
                ))}
            </div>
        </div>
    );
}

export default PastExams;
